import { FunctionComponent, memo, useContext } from "react";
import { IProps } from "./toggle-highlight-writing-issues.types";
import { InteractionContext } from "../interaction-context/interaction-context";
import { faSpellCheck } from "@fortawesome/pro-solid-svg-icons";
import { EllipsisMenuItem } from "@edgetier/client-components";
import { trackUser } from "utilities/track-user";
import "./toggle-highlight-writing-issues.scss";

/**
 * A menu option for toggling whether writing issues should be highlighted in an interaction's messages.
 */
const ToggleHighlightWritingIssues: FunctionComponent<IProps> = () => {
    const { areWritingIssuesVisible, setAreWritingIssuesVisible } = useContext(InteractionContext);
    return (
        <EllipsisMenuItem
            icon={faSpellCheck}
            onClick={() => {
                setAreWritingIssuesVisible((areWritingIssuesVisible) => !areWritingIssuesVisible);
                trackUser("Toggle highlight writing issues", { areWritingIssuesVisible }, true);
            }}
        >
            {`${areWritingIssuesVisible ? "Hide" : "Highlight"} writing issues`}
        </EllipsisMenuItem>
    );
};

export default memo(ToggleHighlightWritingIssues);
